const E = {
  deleteRequestConfirmation: 'Are you sure you want to delete the selected report',
  splitReportSamplesValidationMessage:
    'The Single Sample Report request requires at\nleast two samples in the submission.The selected\nsubmission does not meet the requirement, we are\nunable to process your request.',
  SingleSampleRequestConfirmationMessage:
    'You are about to submit a request for new reports.\nAre you sure you would like to proceed',
  splitReport: 'Split Report',
  splitReports: 'Split Reports',
  split_reports: 'Split reports',
  singleSample: 'Single Sample',
  reportForThisJob: 'for this Job',
  perPDF: 'per PDF',
  singleSampleSuccessMessage: 'Single Sample Request was successfully created.',
  singleSampleErrorMessage: 'Something went wrong. Please try again',
  NoSplitReportRequestsToShow: 'There are currently no split reports available.',
  instructionsLineOne: 'Please select the samples and tests needed for each report.',
  instructionsLineTwo: '1. A selection box will only appear for tests that were analyzed on that sample.',
  instructionsLineThree: '2. The test filter is useful for locating samples for a given test.',
  instructionsLineFour: '3. Modification of parameter lists is not available.',
  requestedBy: 'Requested By ',
  // requestedDate: 'Requested Date ',
  reportName: 'Report Name ',
  filter: 'Filter',
  deleteReportConfirmationMessage: 'Delete this Report',
  createNewReport: '+ Create New Report',
  collapse: 'Collapse',
  expand: 'Expand',
  atLeastOneTestSelected: 'Each report should have at least 1 test selected.',
  requiredFields: 'Required Fields',
  requestedByIsARequiredField: 'Requested By is required',
  requestedDateIsRequired: 'Requested Date is required',
  reportNameIsRequired: 'Report Name is required',
  requestedDate: 'Date Requested ',
  requiredField: 'Required Fields',
  'Report #': 'Report #',
  'Report Name': 'Report Name',
  'Report Date': 'Report Date',
  'Download Link': 'Download Link',
  siteNumber: 'Site Number',
  siteLocation: 'Site Location',
  requestNumber: 'Request #',
  status: 'Status',
  submittedBy: 'Submitted By',
  submittedDate: 'Submitted Date',
  submittedStatus: 'Submission Status',
  taskOrder: 'Task Order',
  reportDate: 'Report Date',
  reportNumber: 'Report Number',
  projectNumber: 'Project Number',
  poNumber: 'PO #',
  modifiedDate: 'Modified Date',
  modifiedBy: 'Modified By',
  lineItem: 'Line Item',
  job: 'Job',
  draft: 'Draft',
  downloadLink: 'Download Link',
  deleteThisReport: 'Delete This Report',
  dateRequested: 'Date Requested',
  createdBy: 'Created By',
  createdDate: 'Created Date',
  costObject: 'Cost Object',
  completed: 'Completed',
  clientName: 'Client Name',
  clientNumber: 'Client Number',
  sampleNumber: 'Sample #',
  singleSampleSuccessMessage: `Your request has been submitted.\nAfter processing, the reports will be sent to the report contacts via email\nand they will also be available to download in the Job Files tab.
`,
  duplicateReportName: 'Report Name must be unique.',
  deleteReportConfirmationMessage1: 'Are you sure you want to delete the selected report',
};

const F = {
  deleteRequestConfirmation: 'Êtes-vous sûr de vouloir supprimer le rapport sélectionné',
  splitReportSamplesValidationMessage:
    "La demande de rapport d'échantillon unique nécessite au moins deux échantillons dans la soumission. La soumission sélectionnée ne répond pas à l'exigence, nous ne sommes pas en mesure de traiter votre demande.",
  SingleSampleRequestConfirmationMessage:
    'Vous êtes sur le point de soumettre une demande de nouveaux rapports.\nVoulez-vous vraiment continuer',
  splitReport: 'Rapport fractionné',
  splitReports: 'Rapports Fractionnés',
  split_reports: 'Rapports fractionnés',
  singleSample: 'Un seul échantillon',
  reportForThisJob: 'pour ce travail',
  perPDF: 'par PDF',
  singleSampleSuccessMessage: 'La demande de rapport pour un seul échantillon a été créée avec succès.',
  singleSampleErrorMessage:
    "Attention!\nLa demande de rapport pour un seul échantillon a échoué.\nVeuillez contacter l'administrateur et signaler ce problème.\nDésolé pour le dérangement.",
  NoSplitReportRequestsToShow: 'Aucun rapport fractionné disponible pour le moment.',
  instructionsLineOne: 'Veuillez sélectionner les échantillons et les tests nécessaires pour chaque rapport.',
  instructionsLineTwo:
    "1. Une boîte de sélection n'apparaîtra que pour les tests qui ont été analysés sur cet échantillon.",
  instructionsLineThree: '2. Le filtre de test est utile pour localiser des échantillons pour un test donné.',
  instructionsLineFour: "3. La modification des listes de paramètres n'est pas disponible.",
  requestedBy: 'Demandé par ',
  // requestedDate: 'Need translation: Requested Date',
  reportName: 'Nom du rapport ',
  filter: 'Filtre',
  deleteReportConfirmationMessage: 'Supprimer ce rapport',
  createNewReport: '+ Créer un nouveau rapport',
  collapse: 'Réduire',
  expand: 'Développer',
  atLeastOneTestSelected: 'Chaque rapport doit avoir au moins 1 test sélectionné.',
  requiredFields: 'Champs obligatoires',
  requestedByIsARequiredField: 'Requested By is required',
  requestedDateIsRequired: 'Requested Date is required',
  reportNameIsRequired: 'Le nom du rapport est requis.',
  requestedDate: 'Date de la demande ',
  requiredField: 'Champs obligatoires',
  'Report #': '#Rapport',
  'Report Name': 'Nom du rapport',
  'Report Date': 'Date du compte rendu',
  'Download Link': 'Lien de téléchargement',
  siteNumber: 'No de site',
  siteLocation: 'Adresse du site',
  requestNumber: '# Demande',
  status: 'Statut',
  submittedBy: 'Demandé par',
  submittedDate: 'Soumis',
  submittedStatus: 'Envoyé',
  taskOrder: "No d'engagement",
  reportDate: 'Date du compte rendu',
  reportNumber: '#Rapport',
  projectNumber: 'No de projet',
  poNumber: 'No de bon de commande',
  modifiedDate: 'Date modifiée',
  modifiedBy: 'Modifié par',
  lineItem: 'No de ligne',
  job: 'No de dossier',
  draft: 'Ébauche',
  downloadLink: 'Lien de téléchargement',
  deleteThisReport: 'Supprimer ce rapport',
  dateRequested: 'Date de la demande',
  createdBy: 'Créé par',
  createdDate: 'Date de création',
  costObject: 'Créé par',
  completed: 'Terminé',
  clientName: 'Nom du client',
  clientNumber: 'Numéro client',
  sampleNumber: 'No d’échantillon',
  singleSampleSuccessMessage: `Votre demande a été soumise.\nAprès traitement, les rapports seront envoyés aux contacts de rapport par\ncourrier électronique et seront également disponibles en téléchargement\ndans l'onglet Fichiers de travail.`,
  duplicateReportName: 'Le nom du rapport doit être unique.',
  deleteReportConfirmationMessage1: 'Êtes-vous sûr de vouloir supprimer le rapport sélectionné',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/splitReports.js